// React
import React from 'react';
// External
import { Container, Pagination } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
// Styles
import './styles.scss';
// Icons
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

/**
 * Custom navigator, works with url search/queryParams, if no query params are found the page is set to 1
 * @param {Object} props.className - Class to be applied to the button
 * @param {Object} props.lastPage - Last page to navigate to, this will limit the navigation to this page
 */
class CustomPagination extends React.Component {
    constructor(props) {
        super(props);
        this.className = 'custom-pagination ';
        this.className += props.className ? props.className : '';

        this.queryParams = new URLSearchParams(props.location.search);
        const page = this.queryParams.get('page');
        // If url has page parameter overwrites the prop
        if (page) {
            this.activePage = parseInt(page, 10);
        }
        // Checks the min page must be 1
        if (this.activePage <= 0 || !this.activePage) {
            this.activePage = 1;
        }
    }

    setPagesAvailable = (activePage, lastPage) => {
        // The max number page to be displayed
        // When last page is less than the number of pages displayed
        const pagesDisplayedCount = 4;
        if (lastPage <= pagesDisplayedCount) {
            return [...Array(lastPage).keys()].map((key) => key + 1);
        }
        // Gets the number of available pages, the difference between the last page and the current page, inclusive (+1)
        const numOfAvailPages = lastPage - activePage + 1;
        if (numOfAvailPages >= pagesDisplayedCount) {
            return [activePage, activePage + 1, activePage + 2, activePage + 3];
        }
        // When the available pages is less than the pages displayed
        // Meaning that the pagination is in the last pages,
        // it should display from the 4th previous page before the last page
        const availPagesArr = [];
        const limit = lastPage - pagesDisplayedCount;
        for (let i = lastPage; i > limit; i -= 1) {
            availPagesArr.push(i);
        }
        return availPagesArr.reverse();
    }

    urlNavigatorConstructor(page) {
        let href = this.props.location.pathname;
        // Pagination added into search url
        if (this.props.location.search === '') {
            href += `?page=${page}`;
        } else {
            // Starts the query with question mark
            href += '?';
            // Loops through hte query params to construct the new url
            this.queryParams.forEach((value, key) => {
                if (key === 'page') {
                    href += `${key}=${page}&`;
                } else {
                    href += `${key}=${value}&`;
                }
            });
            // If query param has params but doesn't contains page, the param page is added
            if (!this.queryParams.get('page')) {
                href += `page=${page}`;
            } else {
                // removes the '&' symbol if the page parameter doesn't need to be added
                href = href.substring(0, href.length - 1);
            }
        }
        // Hash added to the url
        href += this.props.location.hash;
        return href;
    }

    render() {
        return (
            <Container className={this.className}>
                <Pagination>
                    <Pagination.Prev href={this.urlNavigatorConstructor(this.activePage - 1)}
                      disabled={this.props.activePage === 1 || this.props.lastPage === 1 }
                      >
                        <MdKeyboardArrowLeft />
                        Prev
                    </Pagination.Prev>
                    {
                        this.setPagesAvailable(this.props.activePage, this.props.lastPage).map((page) => (
                            <Pagination.Item
                                key={page}
                                className={this.props.activePage === page ? 'active' : 'page-item'}
                                href={this.urlNavigatorConstructor(page)}
                            >
                                {page}
                            </Pagination.Item>
                        ))
                    }
                    <Pagination.Next
                        href={this.urlNavigatorConstructor(this.activePage + 1)}
                        disabled={this.props.activePage === this.props.lastPage}
                    >
                        Next
                        <MdKeyboardArrowRight />
                    </Pagination.Next>
                </Pagination>
            </Container>
        );
    }
}

export default withRouter(CustomPagination);
